import {
    MAIN_LAYOUT,
    MAIN_LAYOUT_FAIL, 
    MAIN_LAYOUT_NO_PERMISSION,
    MAIN_LAYOUT_NOT_CHOOSE_CORP,
    MAIN_LAYOUT_NOT_SIGN_IN,
    MAIN_LAYOUT_RESET, 
    MAIN_LAYOUT_SET_PARAMS, 
    MAIN_LAYOUT_SET_PERMISSIONS,
    MAIN_LAYOUT_SUCCESS
} from './constants';

//
export const MainLayoutReducer = (state = {}, action) => {
    let ret = {
        ...state,
        idKey: Math.random()
    }
    const data = action.payload;
    switch (action.type) {
        case MAIN_LAYOUT_RESET:
            ret.loading = false;
            ret.loadSuccess = null;
            ret.loadDatas = null;
            ret.notSignIn = false;
            ret.notChooseCorp = false;
            ret.noPermission = false;
            ret.permissions = null;
            break;
        case MAIN_LAYOUT_SET_PARAMS:
            ret.params = data.params;
            break;
        case MAIN_LAYOUT_SET_PERMISSIONS:
            ret.permissions = data.permissions;
            break;
        case MAIN_LAYOUT:
            ret.loading = true;
            ret.loadSuccess = null;
            ret.notSignIn = false;
            ret.notChooseCorp = false;
            ret.params = data.params;
            break;
        case MAIN_LAYOUT_SUCCESS:
            ret.loading = false;
            ret.loadSuccess = true;
            ret.loadDatas = data.loadDatas;
            ret.params = data.params;
            break;
        case MAIN_LAYOUT_FAIL:
            ret.loading = false;
            ret.loadSuccess = false;
            ret.error = data;
            break;
        case MAIN_LAYOUT_NOT_SIGN_IN:
            ret.notSignIn = true;
            break;
        case MAIN_LAYOUT_NOT_CHOOSE_CORP:
            ret.notChooseCorp = true;
            break;
        case MAIN_LAYOUT_NO_PERMISSION:
            ret.noPermission = true;
            break;
        default:
            return {...state};
    }
    return ret;
}
